module.exports = __webpack_public_path__ + "img/平方.ef9f8bab.svg";